/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PhoneNumber = {
  properties: {
    value: {
      type: 'string',
      isRequired: true,
    },
    type: {
      type: 'string',
      isRequired: true,
    },
    formattedType: {
      type: 'string',
      isRequired: true,
    },
    canonicalForm: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
